import Hero from "@/components/home/Hero";
import LogosStrip from "@/components/home/LogosStrip";
import AboutPreview from "@/components/home/AboutPreview";
import ServicesGrid from "@/components/home/ServicesGrid";
import WhyChooseUs from "@/components/home/WhyChooseUs";
import BookkeepingFeature from "@/components/home/BookkeepingFeature";
import WhyOutsource from "@/components/home/WhyOutsource";
import StatsBand from "@/components/home/StatsBand";
import Testimonials from "@/components/home/Testimonials";
import FinalCTA from "@/components/FinalCTA";
import Seo from "@/components/Seo";

const Home = () => {
  return (
    <div data-testid="home-page">
      <Seo
        title="Affordable Bookkeeping, Payroll & Consultancy in Aruba"
        description="Best Bizz Financial has helped businesses across Aruba stay organized and confident since 2011 — with personal service and fixed, predictable monthly fees. You own the business. We manage the numbers."
        path="/"
      />
      <Hero />
      <LogosStrip />
      <AboutPreview />
      <ServicesGrid />
      <WhyChooseUs />
      <BookkeepingFeature />
      <WhyOutsource />
      <StatsBand />
      <Testimonials />
      <FinalCTA />
    </div>
  );
};

export default Home;
